module.exports = __webpack_public_path__ + "img/clothing106.904c94ba.jpg";